import React from "react";
import DiscordIcon from "src/assets/icons/socials/mdi_discord.svg";
import GitHubIcon from "src/assets/icons/socials/mdi_github.svg";
import LinkedInIcon from "src/assets/icons/socials/mdi_linkedin.svg";
import MailIcon from "src/assets/icons/socials/mdi_mail.svg";
import MediumIcon from "src/assets/icons/socials/mdi_medium.svg";
import RedditIcon from "src/assets/icons/socials/mdi_reddit.svg";
import TelegramIcon from "src/assets/icons/socials/mdi_telegram.svg";
import TwitterIcon from "src/assets/icons/socials/mdi_twitter.svg";
import classnames from "classnames";
import LogoSVG from "src/assets/images/stratosLogoFooter.svg";
import { StyledTypographyFooterItem } from "src/components/Styled/typography";
import { stratosSocialMediaLinks } from "src/constants/config";
import pageURL from "src/constants/pageURL";
import { NavLink } from "react-router-dom";
import {
  FooterContainer,
  FooterLeft,
  FooterLogo,
  LogoImageContainer,
  NavigationMenu,
  NavigationSubMenu,
  FooterLabel,
  FooterRight,
  SocialLinks,
} from "./StyledFooterComponents";

export const mobileFooter = (backgroundColor: any) => {
  return (
    <FooterContainer
      className={classnames(["footer_container", "mobile_menu"])}
      $backgroundColor={backgroundColor}
    >
      <FooterLeft className={classnames(["footer_left", "mobile_menu"])}>
        <FooterLogo className={classnames(["footer_logo", "mobile_menu"])}>
          <NavLink className="logo_nav_link" to={pageURL.webSite}>
            {() => {
              return (
                <LogoImageContainer className="logo_image_container">
                  <img alt="icon" src={LogoSVG} />
                </LogoImageContainer>
              );
            }}
          </NavLink>
        </FooterLogo>

        <NavigationMenu
          className={classnames(["navigation_menu", "mobile_menu"])}
        >
          <NavLink to={pageURL.webSite}>
            {({ isActive }) => (
              <StyledTypographyFooterItem className={isActive ? "active" : ""}>
                Home
              </StyledTypographyFooterItem>
            )}
          </NavLink>
          <NavLink target="_blank" to={pageURL.home}>
            {({ isActive }) => (
              <StyledTypographyFooterItem className={isActive ? "active" : ""}>
                Blog
              </StyledTypographyFooterItem>
            )}
          </NavLink>
          <NavLink to={pageURL.contactUs}>
            {({ isActive }) => (
              <StyledTypographyFooterItem className={isActive ? "active" : ""}>
                Contact Us
              </StyledTypographyFooterItem>
            )}
          </NavLink>
          <NavLink to={pageURL.resourcesFaq}>
            {({ isActive }) => (
              <StyledTypographyFooterItem className={isActive ? "active" : ""}>
                FAQ
              </StyledTypographyFooterItem>
            )}
          </NavLink>
        </NavigationMenu>
      </FooterLeft>
      <FooterRight className={classnames(["footer_right", "mobile_menu"])}>
        <SocialLinks className="social_links">
          <a
            href={stratosSocialMediaLinks.twtitter}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={TwitterIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.linkedin}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={LinkedInIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.discord}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={DiscordIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.medium}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={MediumIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.github}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={GitHubIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.reddit}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={RedditIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.mailto}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={MailIcon} />
          </a>
          <a
            href={stratosSocialMediaLinks.telegram}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="icon" src={TelegramIcon} />
          </a>
        </SocialLinks>
        <NavigationSubMenu>
          <NavLink to={pageURL.comingSoon}>
            {({ isActive }) => (
              <StyledTypographyFooterItem className={isActive ? "" : ""}>
                Privacy Policy
              </StyledTypographyFooterItem>
            )}
          </NavLink>
          <FooterLabel>
            <StyledTypographyFooterItem>
              © 2024 Stratos
            </StyledTypographyFooterItem>
          </FooterLabel>
        </NavigationSubMenu>
      </FooterRight>
    </FooterContainer>
  );
};
